require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-html-and-html-5-add-a-submit-button-to-a-form.json") })
        }
      }, "path---responsive-web-design-basic-html-and-html-5-add-a-submit-button-to-a-form");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-html-and-html-5-add-a-submit-button-to-a-form!./.cache/json/responsive-web-design-basic-html-and-html-5-add-a-submit-button-to-a-form.json
// module id = 2630
// module chunks = 231608221292675